import { DrawAOIFeature } from "./types";

export const AOI_LAYER_ID = "aoi_layer";
export const AOI_FEATURE_KEY = "aoi_feature";
export const AOI_SOURCE_ID = "aoi_source";
export const EDIT_AOI_SOURCE_ID = "edit-aoi-vertices-source";

export const AOI_DRAWING_FEATURE_COLOR = "rgba(251, 191, 36, 0.2)";
export const AOI_DRAWING_FEATURE_STROKE_COLOR = "rgba(251, 191, 36, 0.5)";
export const AOI_DRAWING_FEATURE_STROKE_WIDTH = 2;

export const AOI_MODIFY_FEATURE_COLOR = "rgba(255, 255, 0, 0.2)";
export const AOI_MODIFY_FEATURE_STROKE_COLOR = "rgba(255, 255, 0, 0.5)";
export const AOI_MODIFY_FEATURE_STROKE_WIDTH = 2;

export const AOI_FEATURE_COLOR = "rgba(255, 0, 255, 0.7)";
export const AOI_FEATURE_STROKE_COLOR = "rgba(255, 0, 255, 1)";
export const AOI_FEATURE_STROKE_WIDTH = 2;

export const AOI_ACTIVE_FEATURE_COLOR = "rgba(255, 0, 0, 0.7)";
export const AOI_ACTIVE_FEATURE_STROKE_COLOR = "rgba(255, 0, 0, 1)";
export const AOI_ACTIVE_FEATURE_STROKE_WIDTH = 2;

export const PREFIX_MAPLIBRE_LAYER = "layer-";
export const PREFIX_MAPLIBRE_SOURCE = "source-";
export const MAPLIBRE_BEFORE_ID = undefined;

export const buildDrawGeoJSON = (features: DrawAOIFeature[]) =>
{
      return {
            type: "FeatureCollection",
            features: features
                  .filter(f => f.visible)
                  .map(f => ({
                        type: "Feature",
                        id: f.id,
                        properties: {
                              ...f.properties,
                              color: f.fill || f.properties?.color || AOI_FEATURE_COLOR, // FIX MÀU
                        },
                        geometry: f.geometry
                  }))
      }
}
